import mixins from '@synergycms_core/less/mixins';

export default {
    footer:{
        backgroundColor:'#EFEFEF',
        textAlign:'center',
        position:'relative',
        zIndex:'1',
        marginTop:'auto',
        width:'100%',
        '@media (min-width:801px)':{
            ...mixins.boxShadow('0 0px 8px -3px #000'),
            padding:'0',
            display:'table',
            zIndex:'10',
            '&:lang(ar)': {
                direction: 'rtl',
            }
        }
    },
    footerContent:{
        '@media (min-width:801px)':{
            maxWidth:'1300px',
            display:'table-cell',
            verticalAlign:'middle',
            width:'100%',
            margin:'0 auto',
            height:'40px',
            position:'static',
            '&:lang(ar)': {
                height: 'auto',
                order: '2',
            }
        }
    },
    footerContentTitleButton:{
        height:'50px',
        width:'100%',
        textAlign:'center',
        padding:'10px 37px',
        textTransform:'uppercase',
        position:'relative',
        backgroundColor:'#EFEFEF',
        color:'#707070',
        fontWeight:'bold',
        borderTop:'1px solid #999'
    },
    footerContentTitleIcon:{
        position:'absolute',
        top:'50%',
        right:'10px',
        marginTop:'-6px'
    },
    footerInfo:{
        margin:'0 auto',
        maxHeight: '400px',
        padding:'20px',
        overflow:'hidden',
        backgroundColor:'#EFEFEF',
        borderTop:'1px solid #999',
        position:'relative',
        '@media (min-width:801px)':{
            border:'none',
            padding:'5px 10px',
        }
    },
    footerLink:{
        position:'relative',
        display:'block',
        marginBottom:'10px',
        textDecoration:'none',
        cursor:'pointer',
        textAlign:'left',
        '@media (min-width:801px)':{
            '&:after':{
                backgroundColor:'#707070',
                bottom:0,
                content: "''",
                height:'100%',
                position:'absolute',
                right:0,
                top:0,
                width:'1px'
            },
            display:'inline-block',
            paddingRight:'10px',
            marginBottom:0,
            marginRight:'10px',
            verticalAlign:'middle',
            margin:'0 auto 10px',
        },
        '&:last-of-type':{
            marginBottom:0,
            '@media (min-width:801px)':{
                '&:after':{
                    content:'none',
                },
                paddingRight:0,
                marginRight:0
            }
        },
        '&:lang(ar)': {
            textAlign: 'right',
        }
    },
    footerLinkText:{
        color:'#707070',
        font: '15px Roboto, sans-serif',
    },
    seeLinksEnter: {
        transition: 'max-height 0ms ease-out',
        maxHeight: '0'
    },
    seeLinksEnterActive: {
        maxHeight: '400px',
        transition: 'max-height 400ms ease-out',
        overflow: 'hidden',
    },
    seeLinksLeave: {
        maxHeight: '400px',
        transition: 'max-height 0 ease-out',
        overflow: 'hidden'
    },
    seeLinksLeaveActive: {
        maxHeight: 0,
        transition: 'max-height  400ms ease-out'
    },
    logoElement:{
        height: '25px',
        fill: '#000',
        marginTop:'6px'
    },
    safeBuy:{
        color:'#707070',
        font: '15px Roboto, sans-serif',
        textTransform:'uppercase'
    },
    footerLeftLogo:{
        minWidth: '120px',
        display:'table-cell',
        verticalAlign:'middle',
        borderRight:'1px solid #999',
        textAlign:'center',
        '&:lang(ar)': {
            order: '3',
            borderRight: 'none',
            borderLeft: '1px solid #999',
        }
    },
    footerRightLogo:{
        composes : '$footerLeftLogo',
        textAlign:'center',
        borderLeft:'1px solid #999',
        borderRight:'none',
        minWidth: '170px',
        marginTop:0,
        boxSizing:'border-box',
        '@media (min-width:801px)':{
            padding:'0 10px',
            '&:lang(ar)': {
                order: '1',
                borderLeft: 'none',
                borderRight: '1px solid #999',
            }
        }
    }
}